import AlertInterface from '../../alert-interface.js';
import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';

// Initialize Notyf instance
const notyf = new Notyf({
    duration: 5000, // default duration
    dismissible: true,
    position: {
        x: 'right',
        y: 'bottom'
    },
    ripple: false,
    types: [
        {
            type: 'info',
            background: '#7239ea',
            icon: {
                className: 'bi bi-info-circle-fill',
                tagName: 'i',
                color: "#ffffff"
            }
        },
        {
            type: 'success',
            background: '#50cd89',
            icon: {
                className: 'bi bi bi-check-circle-fill',
                tagName: 'i',
                color: "#ffffff"
            }
        },
        {
            type: 'warning',
            background: '#ffc700',
            icon: {
                className: 'bi bi-exclamation-triangle-fill',
                tagName: 'i',
                color: "#ffffff"
            }
        },
        {
            type: 'error',
            background: '#f1416c',
            icon: {
                className: 'bi bi-shield-fill-exclamation',
                tagName: 'i',
                color: "#ffffff"
            }
        }
    ]
});

/**
 * Displays a toast message with style based on code
 * 100 - info
 * 200 - success
 * 300 - warning
 * 400 - error
 */
class NotyfAlert extends AlertInterface {
    constructor(data) {
        super();
        this.data = data;
    }

    show() {
        let type = 'info';

        switch (this.data.code) {
            case 100:
                type = 'info';
                break;
            case 200:
                type = 'success';
                break;
            case 300:
                type = 'warning';
                break;
            case 400:
                type = 'error';
                break;
        }

        // Show notification
        const notification = notyf.open({
            type: type,
            message: this.data.message
        });

        // Clipboard copy on click
        notification.on('click', () => {
            copyToClipboard(this.data.message);
            notyf.dismiss(notification);
        });
    }
}

export default NotyfAlert;
